const contenido = {
  createContenido: 'contenido',
  createContenidoComentario: 'contenido/{{uuid_contenido}}/nodo/{{uuid_nodo}}/comentario',
  createContenidoComentarioAprobarReporte: 'comentario/{{uuid_comentario}}/reporte/{{id_reporte}}/aprobar',
  createContenidoComentarioVoto: 'comentario/{{uuid_comentario}}/voto',
  createContenidoEntregable: 'entregable/mensaje/{{uuid_contenido}}',
  createContenidoNodo: 'contenido/{{uuid_contenido}}/nodo',
  createContenidoNodoTarea: 'nodo/{{uuid_nodo}}/tarea',
  deleteContenidoComentario: 'comentario/{{uuid_comentario}}',
  deleteContenidoEntregable: 'entregable/{{uuid_academia}}/{{uuid_entregable}}',
  deleteContenidoNodo: 'contenido/{{uuid_contenido}}/nodo/{{uuid_nodo}}',
  readContenidoComentarioReportes: 'comentario/{{uuid_comentario}}/reportes',
  readContenidoComentarios: 'contenido/{{uuid_contenido}}/nodo/{{uuid_nodo}}/comentarios',
  readContenidoEntregable: 'entregable/{{uuid_contenido}}/{{uuid_entregable}}',
  readContenidoEntregables: 'entregables/{{uuid_contenido}}',
  readContenidoNodos: '{{uuid_contenido}}/nodos',
  readContenidoPreguntasPendientes: '{{uuid_contenido}}/nodos/cantidad',
  readContenidos: '{{uuid_proyecto}}/contenidos',
  updateContenidoActivarNodos: 'entregable/activar-nodos/{{uuid_contenido}}',
  updateContenidoComentarioModerar: 'comentario/{{uuid_comentario}}/moderar',
  updateContenidoEntregable: 'entregable/{{uuid_entregable}}',
  updateContenidoJerarquiasNodos: 'contenido/{{uuid_contenido}}/jerarquias',
  updateContenidoNodo: 'contenido/{{uuid_contenido}}/{{uuid_nodo}}',
  updateContenidoNodoTarea: 'nodo/{{uuid_nodo}}/tarea'
}

export default contenido
